module.exports = __webpack_public_path__ + "img/open.2e73f28a.svg";